import { render, staticRenderFns } from "./BillList.vue?vue&type=template&id=d513087a&scoped=true&"
import script from "./BillList.vue?vue&type=script&lang=js&"
export * from "./BillList.vue?vue&type=script&lang=js&"
import style0 from "./BillList.vue?vue&type=style&index=0&id=d513087a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d513087a",
  null
  
)

export default component.exports